import { Dialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { type WorklistTask } from '@strata/react-worklist';
import { useState } from 'react';

import { usePermissionCheck } from 'services/APIHooks';
import { Permissions } from 'services/constants';
import { useAppDispatch } from 'store';
import { usePutTaskTypeOptOutMutation } from 'store/api/worklistApi';
import { useLoggedInSupplierName } from 'store/auth/authThunks';
import { fetchWorklistTasks } from 'store/worklist/worklistThunks';

interface BlockTasksDialogProps {
    isOpen: boolean;
    worklistTask?: WorklistTask;
    onClose: () => void;
}

export const BlockTasksDialog = ({
    isOpen,
    worklistTask = undefined,
    onClose,
}: BlockTasksDialogProps) => {
    const dispatch = useAppDispatch();
    const pharmacyName = useLoggedInSupplierName();
    const writeWorklist = usePermissionCheck(Permissions.WRITE_WORKLIST);
    const [putTaskTypeOptOut] = usePutTaskTypeOptOutMutation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const blockTasks = () => {
        if (isSubmitting || !worklistTask) {
            return;
        }
        setIsSubmitting(true);
        void (async () => {
            try {
                await putTaskTypeOptOut({
                    taskType: worklistTask.task_type,
                    taskTypeDisplayName: worklistTask.task_type_display_name,
                    enabled: false,
                }).unwrap();
                await dispatch(fetchWorklistTasks());
                SuccessToast({
                    message: 'Tasks blocked.',
                });
                onClose();
            } finally {
                setIsSubmitting(false);
            }
        })();
    };

    return (
        <Dialog
            isOpen={isOpen}
            dialogTitle="Block Task"
            primaryButtonLabel="Yes, Block Task"
            isPrimaryButtonDisabled={!writeWorklist || isSubmitting}
            secondaryButtonLabel="Cancel"
            onSecondaryButtonClick={onClose}
            onPrimaryButtonClick={blockTasks}
            dialogContent={`This will block and remove all “${worklistTask?.task_type_display_name}” tasks for all users at ${pharmacyName}. Do you want to proceed?`}
        />
    );
};
